import { ENTITIES } from '@/api/api.constant';
import { Category, CategoryTranslation } from '@/types/category';
import { apiBaseUrl } from '@/utils/constants';

const fields$s = (
    [
        'id',
        'name',
        'translations.id',
        'translations.language',
        'translations.entity',
        'translations.name',
    ] satisfies Array<keyof Category | `translations.${keyof CategoryTranslation}`>
).join(', ');

export async function get$categories(typeId: string) {
    const filter = {
        status: { _eq: 'active' },
        category_type: { _eq: typeId },
    };
    const filterStr = encodeURIComponent(JSON.stringify(filter));
    const url = `${apiBaseUrl}${ENTITIES.categories}?fields=${fields$s}&filter=${filterStr}&sort[]=name`;
    const response = await fetch(url).then((res) => res.json());
    return response.data ?? [];
}

const fields$detailed = (
    [
        'id',
        'name',
        'translations.id',
        'translations.language',
        'translations.entity',
        'translations.meta_title',
        'translations.meta_description',
        'translations.name',
    ] satisfies Array<keyof Category | `translations.${keyof CategoryTranslation}`>
).join(', ');

export async function get$categoryBySlug(slug: string) {
    const filter = {
        status: { _eq: 'active' },
    };
    const filterStr = encodeURIComponent(JSON.stringify(filter));
    const url = `${apiBaseUrl}${ENTITIES.categories}/${slug}?fields=${fields$detailed}&filter=${filterStr}`;
    const response = await fetch(url).then((res) => res.json());
    return response.data ?? [];
}
